import {h, Component} from 'preact';

class HeaderRightToolBelt extends Component {
    render() {
        return (
            <div style={{
                position: 'absolute',
                right: '15px',
                top: '7px',
                paddingTop: '-3px',
                height: '23px',
            }}>
                {this.props.children}
            </div>
        );
    }


}

export default HeaderRightToolBelt;



// WEBPACK FOOTER //
// ./components/Header/Toolbelt/RightSide.js